<template>
    <div class="action-table">
        <!-- <div class="user-index"> -->
        <!-- <div>
        <a :href="route('tenant.users.assignments.assign', this.user.id)">
            <button class="btn btn-primary">{{trans('assignments.label.assign_courses')}}</button>
        </a>
    </div> -->

        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.name"
                :length="2"
            >
            </colored-letter-square>

            <div slot="actions" slot-scope="props">
                <UserUsergroupTableActions
                    :data="props.row"
                    :index="props.index"
                    :user="user"
                ></UserUsergroupTableActions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    props: ['user', 'debitClients'],

    data() {
        return {
            tableData: [],

            columns: ['cls_column', 'name', 'actions'],

            options: {
                headings: {
                    cls_column: '',
                    name: this.trans('user_groups.label.name'),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['usergroup_title'],
            },
        };
    },

    created() {
        this.fetch();
    },

    mounted() {
        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        EventBus.$on('refreshUsergroups', () => this.fetch());
    },

    methods: {
        fetch() {
            axios
                .get(
                    this.route('tenantapi.users.usergroups.index', this.user.id)
                )
                .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },
};
</script>
